<template>
	<view class="address">
		<view class="address_item" v-for="(item, index) in 3" :key="index">
			<view class="address_item_info">
				<view class="top">
					<text>默认</text>
					<text>刘美女</text>
					<text>15789347769</text>
				</view>
				<view class="bottom">
					上海 上海市 青浦区 夏阳街道华科路新青浦家园144号楼101
				</view>
			</view>
			<image src="@/static/icon/ic_edit@2x.png" mode="widthFix"></image>
		</view>
		<view class="address_footer">
			<view class="address_footer_submit" @click="toAdd">新建收货地址</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			toAdd() {
				uni.navigateTo({
					url: '/pages/operationAddress/index'
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.address {
		width: 100%;
		padding: 32rpx;
		box-sizing: border-box;
		background-color: #ffffff;
		.address_item {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 32rpx;
			padding-bottom: 32rpx;
			border-bottom: 2rpx solid #F4F5F4;
			&:first-child {
				margin-top: 0 !important;
			}
			&:last-child {
				padding-bottom: 0 !important;
				border: none !important;
			}
			.address_item_info {
				width: 504rpx;
				display: flex;
				flex-direction: column;
				.top {
					display: flex;
					align-items: center;
					text {
						&:nth-child(1) {
							padding: 4rpx 6rpx;
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #D20A0A;
							border-radius: 4rpx;
							border: 2rpx solid #D20A0A;
							margin-right: 12rpx;
						}
						&:nth-child(2) {
							font-size: 28rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #333333;
							margin-right: 12rpx;
						}
						&:nth-child(3) {
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #999999;
						}
					}
				}
				.bottom {
					margin-top: 20rpx;
					font-size: 24rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;
				}
			}
			image {
				flex-shrink: 0;
				width: 26rpx;
				height: 26rpx;
				margin-left: 15rpx;
			}
		}
		.address_footer {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			box-sizing: border-box;
			padding: 10rpx 56rpx calc(10rpx + env(safe-area-inset-bottom)) 56rpx;
			background-color: #ffffff;
			.address_footer_submit {
				width: 100%;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
				border-radius: 36rpx 36rpx 36rpx 36rpx;
			}
		}
	}
</style>